import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NotificationsComponent } from './components/notifications/notifications.component';

@NgModule({
  declarations: [NotificationsComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule],
  exports: [NotificationsComponent],
})
export class NotificationsModule {}
